var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": $t("y12dzg6", "添加访问主体")
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm._t("tip"), _c('div', {
    staticClass: "flex gap-2"
  }, [_c('main', {
    staticClass: "flex-1 px-[16px]"
  }, [_c('Tabs', {
    attrs: {
      "animated": false,
      "name": "org-user-tag"
    }
  }, [_c('TabPane', {
    attrs: {
      "tab": "org-user-tag",
      "name": "entry-org",
      "label": $t("gio3m94", "组织架构")
    }
  }, [_c('div', {
    staticClass: "h-[400px] rounded-[4px] overflow-y-auto p-[5px] border-solid border-[#DCDFE6] border-[1px]"
  }, [_c('Input', {
    staticClass: "w-full",
    attrs: {
      "placeholder": $t("7lr2i56", "请输入关键字"),
      "icon": "ios-search"
    },
    model: {
      value: _vm.searchKeys,
      callback: function ($$v) {
        _vm.searchKeys = $$v;
      },
      expression: "searchKeys"
    }
  }), _c('Tree', {
    ref: "orgTreeRef",
    attrs: {
      "check-strictly": "",
      "data": _vm.filterTreeData,
      "render": _vm.renderContent,
      "show-checkbox": "",
      "multiple": ""
    },
    on: {
      "on-check-change": _vm.onCheckChangeOrgTree
    }
  })], 1)])], 1)], 1), _c('main', {
    staticClass: "flex-1 px-[16px]"
  }, [_c('div', {
    staticClass: "h-[37px] mb-[16px] whitespace-normal word-wrap break-word word-break-all"
  }, [_vm._v(` ${$t("j00d9pe", "已选择单位/部门/成员/岗位")} `)]), _c('div', {
    staticClass: "h-[400px] rounded-sm overflow-y-auto border-solid border-[#DCDFE6] border-[1px] p-[5px]"
  }, _vm._l(_vm.entityList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "px-[20px] py-[5px] rounded-[6px] hover:bg-[#ebf2fa] cursor-pointer"
    }, [_c('Icon', {
      staticClass: "mr-2 text-[#3D7FFF]",
      attrs: {
        "type": item.icon
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])], 1);
  }), 0)])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };